import { __awaiter, __generator, __read, __values } from "tslib";
import { read } from '@office-start/idb-cache';
import { logErrorEvent } from '@office-start/instrumentation-service';
import { KnownInstrumentationEvents, } from '@office-start/instrumentation-types';
import { storeName } from './Constants';
import { getDbAndKeyTuple } from './getDbAndKeyTuple';
export function readFromSimplePersistence(_a) {
    var _b;
    var userId = _a.userId, collectionName = _a.collectionName, collectionVersion = _a.collectionVersion, key = _a.key, hashKey = _a.hashKey, _c = _a.plugins, plugins = _c === void 0 ? [] : _c;
    return __awaiter(this, void 0, void 0, function () {
        var item, _d, db, currentKey, plugins_1, plugins_1_1, plugin, e_1_1, e_2;
        var e_1, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    _g.trys.push([0, 11, , 12]);
                    return [4 /*yield*/, getDbAndKeyTuple(userId, collectionName, collectionVersion, key, hashKey)];
                case 1:
                    _d = __read.apply(void 0, [_g.sent(), 2]), db = _d[0], currentKey = _d[1];
                    return [4 /*yield*/, read(db, storeName, currentKey)];
                case 2:
                    item = _g.sent();
                    // If item is not in storage, return `null` indicating the read did not return any data.
                    if (!item) {
                        return [2 /*return*/, null];
                    }
                    _g.label = 3;
                case 3:
                    _g.trys.push([3, 8, 9, 10]);
                    plugins_1 = __values(plugins), plugins_1_1 = plugins_1.next();
                    _g.label = 4;
                case 4:
                    if (!!plugins_1_1.done) return [3 /*break*/, 7];
                    plugin = plugins_1_1.value;
                    if (!plugin.onAfterReadValue) return [3 /*break*/, 6];
                    return [4 /*yield*/, plugin.onAfterReadValue(item, currentKey, {
                            userId: userId,
                            collectionName: collectionName,
                            collectionVersion: collectionVersion,
                        })];
                case 5:
                    item = _g.sent();
                    _g.label = 6;
                case 6:
                    plugins_1_1 = plugins_1.next();
                    return [3 /*break*/, 4];
                case 7: return [3 /*break*/, 10];
                case 8:
                    e_1_1 = _g.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 10];
                case 9:
                    try {
                        if (plugins_1_1 && !plugins_1_1.done && (_e = plugins_1.return)) _e.call(plugins_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                    return [7 /*endfinally*/];
                case 10: return [3 /*break*/, 12];
                case 11:
                    e_2 = _g.sent();
                    logErrorEvent(KnownInstrumentationEvents.SimplePersistenceReadError, (_f = {},
                        _f["Error" /* Error */] = "Error reading from " + collectionName + ": " + ((_b = e_2 === null || e_2 === void 0 ? void 0 : e_2.toString) === null || _b === void 0 ? void 0 : _b.call(e_2)),
                        _f));
                    throw e_2;
                case 12: return [2 /*return*/, item];
            }
        });
    });
}
//# sourceMappingURL=readFromSimplePersistence.js.map